import { render, staticRenderFns } from "./SubCategoryGroup.vue?vue&type=template&id=3fd620e0&"
import script from "./SubCategoryGroup.vue?vue&type=script&lang=js&"
export * from "./SubCategoryGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports